<template>
    <!-- Contractor Modal Modal -->
    <div class="modal fade" id="addListModal" ref="addListModal" tabindex="-1" aria-labelledby="addListModal"
        aria-hidden="true">
        <div
            class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:!w-[500px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
            <div class="modal-content select-none">
                <div class="modal-body !p-3 !pb-5">
                    <div
                        class="relative w-full mobile:h-[70px] tablet:h-[80px] rounded-[10px] overflow-hidden flex items-center justify-start bg-[#2359A8]">
                        <button type="button"
                            class="absolute top-3 right-2.5 w-6 h-6 z-50 focus:!outline-none focus:!shadow-none"
                            data-bs-dismiss="modal" aria-label="Close">
                           <img src="../../../assets/images/modal-cross-icon.svg" alt="Cross Icon"
                                class="w-[30px] h-[30px] object-contain">
                        </button>
                        <div class="relative flex justify-between items-center w-full z-10 ps-3 !pe-12 ">
                            <h6 class="m-0 text-[20px] font-roboto font-normal text-[#fff]">
                                {{ (isEdit) ? 'Edit Affiliate' : 'Add Affiliate' }}
                            </h6>
                        </div>
                    </div>
                    <div ref="scrollBox"
                        class="mobile:max-h-[90vh] desktop:max-h-[70vh] largeDesktop:max-h-[90vh] overflow-y-auto overscroll-auto customScrollbar mobile:mt-2 tablet:mt-4 pr-1.5">
                        <div class="flex flex-col gap-[15px]">
                            <div>
                                <label for="firstName"
                                    class="text-[#999] pb-1 font-roboto text-[13px] 2xl:text-[16px]">First
                                    Name</label>
                                <inputComponent v-model="form.first_name" ref="firstNameRef"
                                    placeholder="Enter First Name" required length="50"
                                    customClass="!w-full h-[40px] !p-[10px] !rounded-[5px] !border !outline-none !text-[12px] largeDesktop:!text-[14px] font-roboto !text-[#333] placeholder:text-[#ccc]" />
                            </div>
                            <div>
                                <label for="lastName"
                                    class="text-[#999] pb-1 font-roboto text-[13px] 2xl:text-[16px]">Last Name</label>
                                <inputComponent v-model="form.last_name" ref="lastNameRef" placeholder="Enter Last Name"
                                    required length="50"
                                    customClass="!w-full h-[40px] !p-[10px] !rounded-[5px] !border !outline-none !text-[12px] largeDesktop:!text-[14px] font-roboto !text-[#333] placeholder:text-[#ccc]" />
                            </div>
                            <div>
                                <label for="email"
                                    class="text-[#999] text-[13px] 2xl:text-[16px] pb-1 font-roboto">Email</label>
                                <inputComponent ref="emailRef" v-model="form.email" name="email"
                                    :regex="$constants.EMAIL_REGEX" error-message="Please enter a valid email address"
                                    placeholder="Enter Email" required length="100"
                                    customClass="!w-full h-[40px] !p-[10px] !rounded-[5px] !border !outline-none !text-[12px] largeDesktop:!text-[14px] font-roboto !text-[#333] placeholder:text-[#ccc]" />
                            </div>
                            <div>
                                <label for="phoneNo"
                                    class="text-[#999] pb-1 font-roboto text-[13px] 2xl:text-[16px]">Phone No.</label>
                                <inputComponent ref="phoneRef" v-model="form.phone" name="phone" mask="(###) ###-####" type="tel"
                                    placeholder="Enter Number" error-message="Invalid phone number" required
                                    customClass="!w-full h-[40px] !p-[10px] !rounded-[5px] !border !outline-none !text-[12px] largeDesktop:!text-[14px] font-roboto !text-[#333] placeholder:text-[#ccc]" />
                            </div>
                            <div>
                                <label class="text-[#999] pb-1 font-roboto text-[13px] 2xl:text-[16px]">Commission
                                    Type</label>
                                <customDropdown v-model="form.distribution_frequency" :items="commissionTypes"
                                    labelKey="title" valueKey="id" buttonText="Select Type"
                                    :button-warpper-class="'relative w-full'"
                                    :buttonClass="'rounded-[5px] border border-[#EFEFEF] flex items-center justify-between px-[10px] py-[3px] w-full'"
                                    :buttonTextClass="[
                                        'font-roboto text-[14px]',
                                        form.distribution_frequency ? 'text-[#333]' : 'text-[#ccc]'
                                    ]" :buttonIconClass="'hidden'" :dropdownListClass="'origin-top-right absolute right-0 mt-2 w-full rounded-md border border-[#EFEFEF] z-20 bg-white'"
                                    :dropdownListLIClass="'rounded-md overflow-hidden hover:bg-gray-200'"
                                    :dropdownListAnchorClass="'no-underline font-roboto block px-2 py-2 text-sm cursor-pointer text-gray-700 hover:bg-gray-200'"
                                    @select="onTypeSelect" />
                                <span v-if="form.distribution_frequency.length <= 0 && isValidate"
                                    class="text-red-500 text-xs">This field is required.</span>
                            </div>
                            <p v-if="!$helper.isEmpty(form.distribution_frequency) && !$helper.isEmpty(getDescription())" class="m-0 text-[12px] italic text-[#999]">"
                                {{ getDescription() }}"</p>
                            <!-- <div>
                                <label for="commission"
                                    class="text-[#999] pb-1 font-roboto text-[13px] 2xl:text-[16px]">Commision</label>
                                <div class="relative">
                                    <div
                                        class="absolute top-0 right-0 w-[40px] h-[35px] flex items-center justify-center mobile:rounded-r-md largeDesktop:rounded-r-lg z-10 text-[#fff] bg-[#F8B134]">
                                        %</div>
                                    <inputComponent ref="commissionRef" v-model="form.commission" name="commission"
                                        placeholder="Enter Commission" required @input="validateCommission"
                                        @blur="formatCommission"
                                        customClass="!w-full h-[40px] !p-[10px] !rounded-[5px] !border !outline-none !text-[12px] largeDesktop:!text-[14px] font-roboto !text-[#333] placeholder:text-[#333]" />

                                    <span v-if="commissionError" class="text-red-500 text-xs">{{ commissionError
                                        }}</span>
                                </div>
                            </div> -->
                        </div>
                        <button @click="submitForm"
                            class="!mt-[50px] !mb-[30px] mb-0 px-[31px] py-[6px] !w-max mx-auto table font-roboto text-sm font-medium rounded-[5px] !border-[1px] border-customBlue-100 text-customBlue-100 hover:text-[#fff] hover:bg-[#2359A8]">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import inputComponent from '../../partialComponent/inputComponent.vue';
import customDropdown from '../../partialComponent/customDropdown.vue';
import { Modal } from "bootstrap";
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
    emits: ["update"],
    components: {
        inputComponent,
        customDropdown
    },
    data() {
        return {
            isValidate: false,
            isEdit: false,
            form: {
                "first_name": "",
                "last_name": "",
                "email": "",
                "phone": "",
                "distribution_frequency": "",
                "commission": "",
            },
            selectedType: null,
            commissionTypes: [

            ],
            commissionError: null,

            // { id: 'monthly', title: "Monthly" },
            // { id: 'one-time', title: "One time" },
        }
    },

    computed: {
        ...mapGetters([
            "affiliateDetails", "affiliateConfig"
        ]),
        
    },
    watch: {
        affiliateDetails: function (data) {
            toast.success(this.isEdit ? "Updated Successfully." : "Added Successfully.");
            if (this.modal)
                this.modal.hide();
            this.$emit('update', true);
        },

        affiliateConfig: function (data) {

            console.log(this.affiliateConfig);


            const updated = this.affiliateConfig.distribution_frequency.map(item => ({
                ...item,
                id: item.value,   // copy value → id

            }));

            // If you want to remove the old "value"
            const finalData = updated.map(({ value, ...rest }) => rest);
            this.commissionTypes = finalData
        }

    },
    methods: {
        ...mapActions([
            "addAffiliate",
            "editAffiliate",
            "getAffiliateConfig"
        ]),
        validateForm() {
            let inputRefer = ["firstNameRef", "lastNameRef", "emailRef", "phoneRef", "commissionRef"]
            let hasError = false;
            inputRefer.forEach(ref => {
                const component = this.$refs[ref];
                const inputComponent = Array.isArray(component) ? component[0] : component;
                if (inputComponent && typeof inputComponent.validate === "function") {
                    inputComponent.validate();
                    if (inputComponent.hasError()) {
                        hasError = true;
                    }
                }
            });
            if (
                this.$helper.isEmpty(this.form.first_name) ||
                this.$helper.isEmpty(this.form.last_name) ||
                this.$helper.isEmpty(this.form.email) ||
                this.$helper.isEmpty(this.form.phone) ||
                this.$helper.isEmpty(this.form.distribution_frequency)
            ) {
                hasError = true;
            }

            this.isValidate = true
            return hasError;
        },

        resetForm() {
            let inputRefer = ["firstNameRef", "lastNameRef", "emailRef", "phoneRef", "commissionRef"]
            inputRefer.forEach(ref => {
                const component = this.$refs[ref];
                const inputComponent = Array.isArray(component) ? component[0] : component;
                if (inputComponent && typeof inputComponent.resetField === "function") {
                    inputComponent.resetField();
                }
            });
        },

        submitForm() {

            if (!this.validateForm()) {
                if (this.isEdit) {
                    this.editAffiliate(this.form)
                } else {
                    this.addAffiliate(this.form)
                }

            }
        },

        editModal(data) {
            this.getAffiliateConfig()
            this.reset()
            this.form = JSON.parse(JSON.stringify(data)),
                this.isEdit = true
            const { Modal } = require('bootstrap');
            const modalEl = this.$refs.addListModal;

            this.modal = Modal.getInstance(modalEl);
            if (!this.modal) {
                this.modal = new Modal(modalEl, {
                    backdrop: 'static',
                    keyboard: false
                });
            }
            // Add event listeners for show/hide
            modalEl.addEventListener('show.bs.modal', () => {
                document.documentElement.style.overflow = 'hidden'; // Target HTML element
                if (window.innerWidth >= 992) {
                    document.documentElement.style.paddingRight = '15px';
                } else {
                    document.documentElement.style.paddingRight = '0px';
                }
            });

            modalEl.addEventListener('hidden.bs.modal', () => {
                document.documentElement.style.overflow = ''; // Reset HTML element
                document.documentElement.style.paddingRight = '0px';
            });

            this.modal.show();
        },

        openModal() {

            this.getAffiliateConfig()

            this.isValidate = false
            this.reset()
            this.isEdit = false
            const { Modal } = require('bootstrap');
            const modalEl = this.$refs.addListModal;

            this.modal = Modal.getInstance(modalEl);
            if (!this.modal) {
                this.modal = new Modal(modalEl, {
                    backdrop: 'static',
                    keyboard: false
                });
            }
            // Add event listeners for show/hide
            modalEl.addEventListener('show.bs.modal', () => {
                document.documentElement.style.overflow = 'hidden'; // Target HTML element
                if (window.innerWidth >= 992) {
                    document.documentElement.style.paddingRight = '15px';
                } else {
                    document.documentElement.style.paddingRight = '0px';
                }
                if (this.$refs.scrollBox) {
                    setTimeout(() => {
                        this.$refs.scrollBox.scrollTo({ top: 0, behavior: "smooth" });
                    }, 200);
                }
            });

            modalEl.addEventListener('hidden.bs.modal', () => {
                document.documentElement.style.overflow = ''; // Reset HTML element
                document.documentElement.style.paddingRight = '0px';
            });

            this.modal.show();
        },

        reset() {
            this.form = {
                "first_name": "",
                "last_name": "",
                "email": "",
                "phone": "",
                "distribution_frequency": ""
            }
            this.resetForm()
        },

        onTypeSelect(item) {
            console.log("Selected:", item);
        },

        validateCommission() {
            let value = this.form.commission ?? ""; // SAFE default for null/undefined

            // Allow only digits & one dot
            value = value.toString().replace(/[^0-9.]/g, "");

            // Max length 5 characters
            if (value.length > 5) {
                value = value.slice(0, 5);
            }

            // Prevent more than one dot
            const dots = (value.match(/\./g) || []).length;
            if (dots > 1) {
                value = value.slice(0, -1);
            }

            const parts = value.split(".");
            // Two decimal digit limit
            if (parts[1] && parts[1].length > 2) {
                parts[1] = parts[1].slice(0, 2);
                value = parts.join(".");
            }

            let numValue = parseFloat(value);

            // Allow temporary "." while typing
            if (value === "." || isNaN(numValue)) {
                this.form.commission = value;
                this.commissionError = "Please enter a valid number";
                return;
            }

            // Validation limit check (0 <= value <= 50.00)
            if (numValue < 0) {
                this.commissionError = "Value must be 0 or greater";
            } else if (numValue > 50) {
                this.commissionError = "Value must be 50.00 or less";
            } else {
                this.commissionError = null;
            }

            this.form.commission = value;
        }
        ,

        // Format: always 2 decimals on blur
        formatCommission() {
            if (
                this.form.commission !== "" &&
                !isNaN(parseFloat(this.form.commission))
            ) {
                this.form.commission = parseFloat(this.form.commission).toFixed(2);
            }
        },

        getDescription() {
            let res = (this.commissionTypes ?? []).find(item => item.id == this.form.distribution_frequency)
            return res?.description || ''
        }
    }
}
</script>